"use strict";

/*==============================================================================
TRESTLE™ W004
POPUP TOOL — PCOS SELF-CHECK
==============================================================================*/

window.TRESTLE_W004_TOOLS =
    window.TRESTLE_W004_TOOLS || {};


window.TRESTLE_W004_TOOLS.pcos_self_check = {

    render(){

        return `

        <div class="tr-w004-pcos-tool">

            <p class="dia-pcos-subtitle">
                Tick the symptoms that apply to you and calculate your score below.
            </p>


            <div class="dia-pcos-layout">


                <div class="dia-symptom-column">

                    <div class="dia-symptom-item">

                        <input
                        type="checkbox"
                        id="dia_c1">

                        <label for="dia_c1">
                            Irregular or unpredictable periods
                        </label>

                    </div>


                    <div class="dia-symptom-item">

                        <input
                        type="checkbox"
                        id="dia_c2">

                        <label for="dia_c2">
                            Persistent acne
                        </label>

                    </div>


                    <div class="dia-symptom-item">

                        <input
                        type="checkbox"
                        id="dia_c3">

                        <label for="dia_c3">
                            Difficulty losing weight
                        </label>

                    </div>


                    <div class="dia-symptom-item">

                        <input
                        type="checkbox"
                        id="dia_c4">

                        <label for="dia_c4">
                            Dark skin around neck or underarms
                        </label>

                    </div>

                </div>


                <div>

                    <div class="dia-pcos-center-circle">

                        <img
                        src="https://cdn.shopify.com/s/files/1/0588/5250/7777/files/PMOS_Center_Image.png?v=1780315325"
                        alt="PCOS Self Check">

                    </div>

                </div>


                <div class="dia-symptom-column">

                    <div class="dia-symptom-item">

                        <input
                        type="checkbox"
                        id="dia_c5">

                        <label for="dia_c5">
                            Excess facial or body hair
                        </label>

                    </div>


                    <div class="dia-symptom-item">

                        <input
                        type="checkbox"
                        id="dia_c6">

                        <label for="dia_c6">
                            Hair thinning or hair loss
                        </label>

                    </div>


                    <div class="dia-symptom-item">

                        <input
                        type="checkbox"
                        id="dia_c7">

                        <label for="dia_c7">
                            Family history of diabetes
                        </label>

                    </div>

                </div>


            </div>


            <div class="dia-score-area">

                <button
                type="button"
                class="dia-check-btn"
                data-pcos-calculate>

                    Calculate My Score

                </button>


                <div class="dia-score-box">

                    <div class="dia-score-number">

                        Score:
                        <span id="diaPcosScore">0</span>

                    </div>


                    <div
                    class="dia-result-title"
                    id="diaPcosResult">

                        Low Concern

                    </div>


                    <div id="diaPcosMessage">

                        Select your symptoms and click Calculate My Score.

                    </div>

                </div>

            </div>


            <div class="dia-disclaimer">

                <strong>Important:</strong>

                This self-check is for educational purposes only and is not intended to diagnose PCOS.
                Please consult a qualified healthcare professional for medical advice.

            </div>

        </div>

        `;

    },


/*==============================================================================
INIT
==============================================================================*/

    init(container){

        if(!container){

            return;

        }

        const button =
            container.querySelector(
                "[data-pcos-calculate]"
            );

        if(!button){

            return;

        }

        button.addEventListener(
            "click",
            ()=>{
                this.calculate(container);
            }
        );

    },


/*==============================================================================
CALCULATE
==============================================================================*/

    calculate(container){

        let score = 0;

        for(let i = 1; i <= 7; i++){

            const checkbox =
                container.querySelector(
                    "#dia_c" + i
                );

            if(
                checkbox &&
                checkbox.checked
            ){

                score++;

            }

        }


        const scoreElement =
            container.querySelector(
                "#diaPcosScore"
            );

        const resultElement =
            container.querySelector(
                "#diaPcosResult"
            );

        const messageElement =
            container.querySelector(
                "#diaPcosMessage"
            );


        if(scoreElement){

            scoreElement.textContent = score;

        }


        if(
            !resultElement ||
            !messageElement
        ){

            return;

        }


        if(score <= 1){

            resultElement.textContent =
                "Low Concern";

            messageElement.textContent =
                "You currently report very few common symptoms associated with PCOS.";

        }

        else if(score <= 3){

            resultElement.textContent =
                "Consider Medical Evaluation";

            messageElement.textContent =
                "You report several symptoms that may warrant discussion with a healthcare professional.";

        }

        else{

            resultElement.textContent =
                "Strongly Consider Consulting a Healthcare Professional";

            messageElement.textContent =
                "You report multiple symptoms commonly associated with PCOS and may benefit from professional evaluation.";

        }

    }

};